document.querySelectorAll('[data-vacancy]').forEach((btn) => {
	btn.addEventListener('click', (e) => {
		e.preventDefault();
		const popup = document.querySelector(btn.dataset.vacancy)
		if (popup) {
			popup.classList.add('_display')
			setTimeout(function () {
				popup.classList.add('_animate')
			}, 50)
		}
	})
})

document.querySelectorAll('.vacancy-popup').forEach((popup) => {
	popup.querySelector('.vacancy-popup__close')?.addEventListener('click', () => {
		popup.classList.remove('_animate')
		setTimeout(function () {
			popup.classList.remove('_display')
		}, 500)
	});
})

document.querySelectorAll('.href-link').forEach((link) => {
	link.addEventListener("click", function (e) {
        e.preventDefault();

		const targetId = this.getAttribute('href');
		const targetSection = document.querySelector(targetId);
		
		if (targetSection) {
				window.scrollBy({
				top: targetSection.getBoundingClientRect().top-160,
				behavior: "smooth"
			});
		}
 
       
    });
        
});

document.querySelectorAll('.href-menu').forEach((menu) => {
            const menuLinks = menu.querySelectorAll('a');
            
            menuLinks.forEach(link => {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    const targetId = this.getAttribute('href');
                    const targetSection = document.querySelector(targetId);
                    
                    if (targetSection) {
                        targetSection.scrollIntoView({
                            behavior: 'smooth',
							block: 'start'
                        });
                        
                        history.pushState(null, null, targetId);
                    }
                });
            });
            
            window.addEventListener('scroll', function() {
                let currentSection = '';
				menuLinks.forEach((it)=>{
					const section = document.querySelector(it.getAttribute('href'))
                    const sectionTop = section.offsetTop;
                    const sectionHeight = section.clientHeight;
                    
                    if (pageYOffset >= sectionTop - 100) {
                        currentSection = section.getAttribute('id');
                    }
                });
                
                menuLinks.forEach(link => {
                    link.classList.remove('_active');
                    if (link.getAttribute('href') === `#${currentSection}`) {
                        link.classList.add('_active');
                    }
                });
            });
        });